
export class RecipeDownloadScreenModel {
    /**
     * レシピID
     */
    recipeId: string | null = null;
}
